import { bootFrontend } from "../shared/bootstrap";
import { quoteSlider } from "./quote-slider";

bootFrontend({ beforeStart: ({ Alpine }) => Alpine.data("quoteSlider3cBolig", quoteSlider) });

const updateHeader = () => {
    document.body.classList.toggle("scrolled", window.scrollY > 40);
};

window.addEventListener("scroll", updateHeader, { passive: true });
updateHeader();
